import {
  Component,
  OnInit,
  ElementRef,
  Input,
  Inject,
  Renderer2,
  ViewChild,
  ChangeDetectorRef,
  AfterViewInit,
  OnDestroy,
} from '@angular/core';
import * as Cesium from 'cesium';
import { Data } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { normalizeTaskTarget } from 'src/app/shared/utils/geo.utils';
import { OPERATORS, RF_RADIUS } from 'src/app/services/constants';
import { Color } from 'cesium';
import { ApiService } from 'src/app/services/api.service';
import * as moment from 'moment';
import { overlays } from '../../../config/baseLayer';
import * as L from 'leaflet';
import 'leaflet-draw';
import 'leaflet-arrowheads';
import 'leaflet-geometryutil';
import 'leaflet-polylinedecorator';
import { AuthService } from 'src/app/services/auth.service';
import { Subscription } from 'rxjs';
import { PopupService } from 'src/app/services/popup.service';
import { CollectionPopupComponent } from '../collection-popup/collection-popup.component';
var turf = require('@turf/turf');
var geoParse = require('wellknown');

type SatellitePositionEntry = {
  coordinates?: number[];
  timeStamp?: string;
  timestamp?: string;
};

type SatelliteTrackPoint = {
  latLng: L.LatLngTuple;
  timeStamp?: string;
};

const cesiumContainer = document.createElement('div');
cesiumContainer.id = 'cesiumGlobeContainer';
document.getElementsByTagName('body')[0].appendChild(cesiumContainer);

@Component({
  selector: 'app-previescreen',
  templateUrl: './previescreen.component.html',
  styleUrls: ['./previescreen.component.scss']
})
export class PreviescreenComponent implements OnInit, AfterViewInit, OnDestroy {
  private map: L.Map;
@ViewChild('map', { static: true }) mapContainer!: ElementRef;
  isFullscreen = false;
  private readonly fullscreenChangeHandler = this.onFullscreenChange.bind(this);
  @Input() target: any = { geoJSON: '', area: 0 };
  mapSnap: any;
  defaultLL: any[] = [82.9739, 25.3176];
  roll: any = 0;
  viewer: any = null;
  scene: any = null;
  longLatStr: string = '';
  taskTarget: any;
  taskid: any;
  taskname: any;
  coordinates: any = [];
  zoomLevel = 3;
  observationCoordinates: any = [];
  observationCoordinatesDisplay: any = [];

  title = 'Confirmation';
  cancelBtn = 'Cancel Task';
  btnParams = 'CANCEL';
  successMsg: any;
  currentUser: any;
  taskMap: any;
  sensors: any;
  targetPoints: any;
  dataLoading: boolean = true;
  retask:boolean = false;
  mapFontColor = 'black';
   mapDistance = 0;
   private satelliteDataSubscription: Subscription | null = null;
   private satLayer: L.LayerGroup | null = null;
    private marker?: L.Marker; 
  private geoJsonLayer?: L.Layer;
  private drawnItems?: L.FeatureGroup;
  private latlonOverlay?: HTMLDivElement;
private latlonMoveHandler?: (e: L.LeafletMouseEvent) => void;
private latlonOutHandler?: () => void;
private satRenderer?: L.SVG;
  observationLocation: any;
  observationType: any;
  cordinateLabel: string = 'Coordinates';
  constructor(

    private dialogRef: MatDialogRef<PreviescreenComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Data,
    private el: ElementRef, private renderer: Renderer2,
    private apiService: ApiService,
     private popupService: PopupService,
     private changDetectionRef: ChangeDetectorRef,
     private authService: AuthService,
  ) {
    this.authService.user.subscribe(user => this.currentUser = user);
    if (data['type'] === 'taskPreview') {
    this.taskid = data['taskid'];
    this.taskname = data['taskname'];
    this.taskTarget = JSON.parse(normalizeTaskTarget(this.data['target']));
    this.sensors = data['sensors'];
    this.targetPoints = this.data['targetPoints'] ? JSON.parse(this.data['targetPoints']) : null;
    this.observationLocation = this.data['observationLocation'];

    this.coordinates = [];
    if (this.taskTarget)
      if (this.taskTarget.type === 'Polygon') {
        this.coordinates = this.taskTarget.coordinates[0]
          .toString()
          .split(',')
          .map(Number);
      } else if (this.taskTarget?.length > 1) {
        this.taskTarget.type = this.taskTarget[0].type;
        for (const points of this.taskTarget) {
          this.coordinates.push(points.coordinates)
        }
      } else {
        this.coordinates = this.taskTarget.coordinates;
      }
    }

    if (this.observationLocation) {
      let observationCoordinatesSplit = this.observationLocation.includes(';') ? this.observationLocation.split(';') : this.observationLocation;
      this.observationCoordinatesDisplay = observationCoordinatesSplit.toString().split(',').map(Number);
      this.observationCoordinates = this.observationLocation.split(';');
      if (this.observationCoordinates.length === 1) {
        this.observationType = 'Point';
      } else {
        this.observationType = 'Polygon';
      }
      this.cordinateLabel = 'Tipping Coordinates';
    }
  }

  ngOnInit(): void {
  }
  
  async ngAfterViewInit() {
    await this.initializeMap();
    this.renderInitialOverlay();
  }

  toggleFullscreen() {
    const elem = this.mapContainer?.nativeElement;
    if (!elem) {
      return;
    }

    if (document.fullscreenElement !== elem) {
      this.isFullscreen = true;
      this.changDetectionRef.detectChanges();
      if (elem.requestFullscreen) {
        elem.requestFullscreen().then(() => this.map?.invalidateSize());
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen().then(() => this.map?.invalidateSize());
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen().then(() => this.map?.invalidateSize());
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen().then(() => this.map?.invalidateSize());
      }
      return;
    }

    this.isFullscreen = false;
    this.changDetectionRef.detectChanges();
    if (document.exitFullscreen) {
      document.exitFullscreen().then(() => this.map?.invalidateSize());
    }
  }

  onFullscreenChange() {
    this.isFullscreen = document.fullscreenElement === this.mapContainer?.nativeElement;
    this.map?.invalidateSize();
    this.changDetectionRef.detectChanges();
  }

  private renderInitialOverlay(): void {
    if (!this.map) {
      return;
    }

    if (this.data['type'] === 'taskPreview') {
      this.plotTarget();
      return;
    }

    if (this.data['type'] === 'satelliteTracking') {
      this.plotSatelliteTrackingTarget();
      return;
    }

    if (this.data['type'] === 'permittedArea') {
      this.plotArea(this.data['user']?.taskableAoi || []);
    }
  }
   private async initializeMap() {
      const baseLayers = {
        Openstreetmap: L.tileLayer(
          'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
          { noWrap: true }
        ),
      };
      this.map = L.map(this.mapContainer.nativeElement, {
        maxBounds: [
          [-90, -180],
          [90, 180]
        ],
        maxBoundsViscosity: 1.0,
        zoom: this.zoomLevel,
        layers: [baseLayers.Openstreetmap], // Set the initial (default) layer
        attributionControl: false,
        minZoom: 1,
        maxZoom: 18
      });
      
      var myAttrControl = L.control.attribution().addTo(this.map);
      myAttrControl.setPrefix('<a href="https://leafletjs.com/">Leaflet</a>');
  
      setTimeout(() => {
        this.map.invalidateSize();
        this.changDetectionRef.detectChanges();
      }, 0);
      
      L.control
        .layers(baseLayers, overlays, {
          collapsed: false, // Optionally control whether the control is collapsed by default
          position: 'topright', // Optionally set the position of the control
        })
        .addTo(this.map);
  
        if(this.retask == false) {
  
          const url = `https://nominatim.openstreetmap.org/search?format=json&q=${this.currentUser.country}`;
    
          try {
            const response = await fetch(url);
            const data = await response.json();
    
            if (data && data.length > 0) {
              const lat = data[0].lat;
              const lon = data[0].lon;
              this.map.setView([lat, lon], 10);
            } else {
             this.map.setView([20.5937, 78.9629], 10);
            }
          } catch (error) {
            this.map.setView([20.5937, 78.9629], 10);
          }
        }
  
        L.Icon.Default.mergeOptions({
          iconUrl: '../../../assets/map-icons/marker-icon.png',  
          iconSize: [25, 41],                
          iconAnchor: [12, 41],              
          popupAnchor: [1, -34],               
          shadowUrl: '../../../assets/map-icons/marker-shadow.png', 
          shadowSize: [41, 41],      
          shadowAnchor: [12, 41]      
        });
  
      setTimeout(() => {
        const layersControlElement = document.querySelector(
          '.leaflet-control-layers'
        );
        if (layersControlElement) {
          const container = document.getElementsByClassName(
            'leaflet-control-layers-expanded'
          )[0];
          container?.classList.remove('leaflet-control-layers-expanded');
        }
      }, 0);
  
      
  
      this.map.on('baselayerchange', (event: any) => {
        let layerBtn: any = document.querySelector('.leaflet-control-layers-toggle');
        layerBtn.classList.remove('highlight-border');
        const container = document.getElementsByClassName(
          'leaflet-control-layers-expanded'
        )[0];
        if (container) {
          container.classList.remove('leaflet-control-layers-expanded');
          document.querySelector('.leaflet-control-layers-toggle')?.setAttribute('style', 'top:0px !important')
        }
        const element = document.querySelector('#homeButton');
        if (element) {
          this.renderer.setStyle(element, 'z-index', '500');
        }
        if (event.name === "Openstreetmap") {
          this.mapFontColor = 'black';
          myAttrControl.setPrefix('<a href="https://leafletjs.com/">Leaflet</a>');
          myAttrControl.removeAttribution('<a href="https://scihub.copernicus.eu/" target="_blank">Copernicus Sentinel data 2020</a>');
          myAttrControl.addAttribution('&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> contributers');
          const elements = document.querySelectorAll('[id^="custom-div"]');
          elements.forEach((element: any) => {
            element.style.color = this.mapFontColor
          });
        } else {
          this.mapFontColor = 'white';
          myAttrControl.setPrefix('<a href="https://leafletjs.com/">Leaflet</a>');
          myAttrControl.removeAttribution('&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> contributers');
          myAttrControl.addAttribution('<a href="https://scihub.copernicus.eu/" target="_blank">Copernicus Sentinel data 2020</a>');
          const elements = document.querySelectorAll('[id^="custom-div"]');
          elements.forEach((element: any) => {
            element.style.color = this.mapFontColor
          });
        }
      });
  
      this.map.createPane('left');
      this.map.createPane('right');
      this.map.on('baselayerchange', (e: any) => {
        this.map.off('layerremove');
        this.map.off('layeradd');
      });
      this.map.on('layeradd', (e: any) => {});
      this.map.on('layerremove', (e: any) => {
        this.map.off('layerremove');
      });
      this.initLatLonOverlay();
  
      document.querySelector('.leaflet-control-layers-toggle')?.addEventListener('click', (e) => {
        this.removeHighlight();
        let layerBtn: any = document.querySelector('.leaflet-control-layers-toggle');
        layerBtn.classList.add('highlight-border');
        if(document.querySelector('.leaflet-control-layers-expanded')) {
          document.querySelector('.leaflet-control-layers-toggle')?.setAttribute('style', 'top:-48px !important')
        }
  
        const searchBtnParentEl = document.querySelector('.leaflet-geosearch-button') as HTMLElement;
        const searchInput = document.querySelector('.leaflet-geosearch-button form input') as HTMLInputElement;
        if(!searchInput.value && !searchInput.classList.contains('active')) {
          searchBtnParentEl.classList.remove('active');
        }
      })
  
      this.map.on('click', function () {
        //clearing search input
        const searchInput: any = document.querySelector('.leaflet-control-geocoder-form input');
        if(searchInput?.value) {
          searchInput.value = "";
        }
  
        let links = document.querySelectorAll('.leaflet-draw-toolbar span a');
        links.forEach((s: any) => s.classList.remove('highlight-border'));
        let homeBtn: any = document.querySelector('#homeButton');
        homeBtn.classList.remove('highlight-border');
        let layerBtn: any = document.querySelector('.leaflet-control-layers-toggle');
        layerBtn.classList.remove('highlight-border');
        var controlContainer = document.getElementsByClassName(
          'leaflet-control-layers-expanded'
        )[0];
        if (
          controlContainer &&
          controlContainer.classList.contains('leaflet-control-layers-expanded')
        ) {
          controlContainer.classList.remove('leaflet-control-layers-expanded');
          document.querySelector('.leaflet-control-layers-toggle')?.setAttribute('style', 'top:0px !important')
        } 
  
        const searchBtnParentEl = document.querySelector('.leaflet-geosearch-button') as HTMLElement;
        searchBtnParentEl.classList.remove('active');
        
      });
  
      const mapContainer: any = document.getElementById('map');
      const zoomDiv = document.getElementById('zoomDiv');
      mapContainer.appendChild(zoomDiv);
      const logoDiv = document.getElementById('logoDiv');
      mapContainer.appendChild(logoDiv);
      document.addEventListener('fullscreenchange', this.fullscreenChangeHandler);
      this.map.removeControl(this.map.zoomControl);
      const zoomControl = new L.Control.Zoom({ position: 'bottomright' });
      zoomControl.addTo(this.map);
     this.map.whenReady(() => {
       this.calculateZoomLevel();
     });
      this.map.on('zoomend', this.HandleZoomEnd);
      this.changDetectionRef.detectChanges();
      if (this.data['type'] === 'satelliteTracking')  {
      this.dataLoading = true;
      this.getSatelliteData();
    }
    }
     removeHighlight() {
    let homeBtn: any = document.querySelector('#homeButton');
    if(homeBtn) {
      homeBtn.classList.remove('highlight-border');
    }
    let layerBtn: any = document.querySelector('.leaflet-control-layers-toggle');
    if(layerBtn) {
      layerBtn.classList.remove('highlight-border');
    }
  }
   HandleZoomEnd = () => {
    this.calculateZoomLevel();
  };
   calculateZoomLevel = () => {
    this.zoomLevel = this.map.getZoom();
    const bounds = this.map.getBounds();
    const distance = bounds.getSouthWest().distanceTo(bounds.getNorthEast());
    this.mapDistance = distance / 1000;
  };

zoomtoLocation(): void {
  if (!this.map) return;
  if (this.marker && typeof (this.marker as any).getLatLng === 'function') {
    const latlng = (this.marker as any).getLatLng();
    this.map.flyTo(latlng, this.zoomLevel || 7, { 
      animate: true, 
      duration: 1.5 
    });
    return;
  }

  if (this.geoJsonLayer && typeof (this.geoJsonLayer as any).getBounds === 'function') {
    try {
      const bounds = (this.geoJsonLayer as any).getBounds();
      if (bounds?.isValid()) {
        this.map.flyToBounds(bounds, {
          padding: [50, 50],
          maxZoom: 7,
          animate: true,
          duration: 1.5
        });
        return;
      }
    } catch (e) {
    }
  }

  const dataSourceLayers = [this.satLayer, this.drawnItems];
  
  for (const layer of dataSourceLayers) {
    if (layer) {
      // For layer groups
      if (typeof (layer as any).getBounds === 'function') {
        try {
          const bounds = (layer as any).getBounds();
          if (bounds?.isValid()) {
            this.map.flyToBounds(bounds, {
              padding: [50, 50],
              maxZoom: 7,
              animate: true,
              duration: 1.5
            });
            return;
          }
        } catch (e) {
        }
      }
      // For feature groups with layers
      else if (typeof (layer as any).getLayers === 'function') {
        const layers = (layer as any).getLayers();
        if (layers && layers.length > 0) {
          const group = L.featureGroup(layers);
          const bounds = group.getBounds();
          if (bounds?.isValid()) {
            this.map.flyToBounds(bounds, {
              padding: [50, 50],
              maxZoom: 7,
              animate: true,
              duration: 1.5
            });
            return;
          }
        }
      }
    }
  }

  
  // if (this.lattitude && this.longitude) {
  //   this.map.flyTo([this.lattitude, this.longitude], this.zoomLevel || 7, {
  //     animate: true,
  //     duration: 1.5
  //   });
  //   return;
  // }

  // 5) Last resort - scan all layers on map
  const allBounds = L.latLngBounds([]);
  let foundAny = false;

  this.map.eachLayer((layer: any) => {
    if (typeof layer.getBounds === 'function') {
      try {
        const b = layer.getBounds();
        if (b?.isValid()) {
          allBounds.extend(b);
          foundAny = true;
        }
      } catch (e) {}
    } else if (typeof layer.getLatLng === 'function') {
      try {
        const ll = layer.getLatLng();
        allBounds.extend(ll);
        foundAny = true;
      } catch (e) {}
    }
  });

  if (foundAny && allBounds.isValid()) {
    this.map.flyToBounds(allBounds, {
      padding: [50, 50],
      maxZoom: 7,
      animate: true,
      duration: 1.5
    });
  } else {
    this.map.setView([0, 0], 2);
  }
}

  plotTarget() {
    if (!this.map || !this.taskTarget) {
      return;
    }

    const isLBandIncluded = Array.isArray(this.sensors)
      ? this.sensors.some((item) => item.operatorKey === OPERATORS.LBAND)
      : false;

    if (Array.isArray(this.taskTarget) && this.taskTarget.length > 1) {
      this.plotMultiPointTarget(this.taskTarget);
    } else if (this.taskTarget.type === 'Polygon') {
      this.plotPolygonTarget(this.taskTarget.coordinates[0]);
    } else if (this.taskTarget.type === 'Point') {
      this.plotPointTarget(this.taskTarget.coordinates, isLBandIncluded);
    }

    this.plotObservationOverlay();
  }

  private plotPointTarget(coordinates: number[], isLBandIncluded = false): void {
    const [lng, lat] = coordinates;
    this.clearPreviewLayers();
    this.marker = L.marker([lat, lng]).addTo(this.map);

    if (isLBandIncluded) {
      L.circle([lat, lng], {
        radius: RF_RADIUS * 1000,
        color: 'blue',
        fillColor: '#add8e6',
        fillOpacity: 0.25,
      }).addTo(this.map);
    }

    this.map.flyTo([lat, lng], 7, {
      animate: true,
      duration: 1.5,
    });
  }

  private plotPolygonTarget(coordinates: number[][]): void {
    this.clearPreviewLayers();
    const latLngs = coordinates.map(([lng, lat]) => [lat, lng] as [number, number]);
    this.geoJsonLayer = L.polygon(latLngs, {
      color: 'yellow',
      weight: 2,
      fillOpacity: 0.1,
    }).addTo(this.map);
    this.map.flyToBounds((this.geoJsonLayer as L.Polygon).getBounds(), {
      padding: [20, 20],
      duration: 1.5,
    });
  }

  private plotMultiPointTarget(features: any[]): void {
    this.clearPreviewLayers();
    const layers: L.Layer[] = [];

    features.forEach((feature, index) => {
      if (feature?.type !== 'Point' || !Array.isArray(feature?.coordinates)) {
        return;
      }

      const [lng, lat] = feature.coordinates;
      const marker = L.marker([lat, lng]).bindTooltip(String(index + 1), {
        permanent: true,
        direction: 'top',
        offset: L.point(0, -10),
      });
      layers.push(marker);
    });

    if (layers.length === 0) {
      return;
    }

    this.drawnItems = L.featureGroup(layers).addTo(this.map);
    this.map.flyToBounds(this.drawnItems.getBounds(), {
      padding: [20, 20],
      duration: 1.5,
    });
  }

  private plotObservationOverlay(): void {
    if (!this.map || !this.observationCoordinates?.length) {
      return;
    }

    if (this.observationType === 'Point') {
      const [lng, lat] = this.observationCoordinates[0].split(',').map(Number);
      L.circleMarker([lat, lng], {
        radius: 6,
        color: 'red',
        fillColor: 'red',
        fillOpacity: 1,
      }).addTo(this.map);
      return;
    }

    const latLngs = this.observationCoordinates
      .map((coordinate) => coordinate.split(',').map(Number))
      .filter((coordinate) => coordinate.length === 2)
      .map(([lng, lat]) => [lat, lng] as [number, number]);

    if (latLngs.length > 1) {
      L.polyline(latLngs, {
        color: 'red',
        weight: 2,
      }).addTo(this.map);
    }
  }

  private clearPreviewLayers(): void {
    if (this.marker) {
      this.map.removeLayer(this.marker);
      this.marker = undefined;
    }

    if (this.geoJsonLayer) {
      this.map.removeLayer(this.geoJsonLayer);
      this.geoJsonLayer = undefined;
    }

    if (this.drawnItems) {
      this.drawnItems.clearLayers();
      this.map.removeLayer(this.drawnItems);
      this.drawnItems = undefined;
    }
  }

  drawCircles(coordinates) {
    const radius = RF_RADIUS * 1000;
    const lng = coordinates[0],
      lat = coordinates[1];

      // Create a circle entity for each point
      this.viewer.entities.add({
        name:'circles',
        position: Cesium.Cartesian3.fromDegrees(lng, lat),
        ellipse: {
          semiMajorAxis: radius,
          semiMinorAxis: radius,
          material: Color.BLUE.withAlpha(0.4)
        },
        billboard: {
          image: 'assets/images/marker-icon.png',
          show: true, // default
          eyeOffset: new Cesium.Cartesian3(0.0, 0.0, 0.0), // default
          horizontalOrigin: Cesium.HorizontalOrigin.CENTER, // default
          verticalOrigin: Cesium.VerticalOrigin.BOTTOM, // default: CENTER
          alignedAxis: Cesium.Cartesian3.ZERO, // default
          width: 20, // default: undefined
          height: 30, // default: undefined
        },
      });
  }

  createGeoJSONFile(features: any[]) {
    const geoJSON = {
      type: 'FeatureCollection',
      features: features.map((feature) => ({
        type: 'Feature',
        geometry: {
          type: feature.type,
          coordinates: feature.coordinates,
        },
      })),
    };
  
  let selectData: any;
  selectData = Cesium.GeoJsonDataSource.load(geoJSON);

  selectData.then((dataSource) => {
    const entities = dataSource.entities.values;
    for (let i = 0; i < entities.length; i++) {
      const entity = entities[i];
      entity.billboard = new Cesium.BillboardGraphics({
        image: 'assets/images/marker-icon.png',
        show: true,
        eyeOffset: new Cesium.Cartesian3(0.0, 0.0, 0.0),
        horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
        verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
        alignedAxis: Cesium.Cartesian3.ZERO,
        width: 20,
        height: 30,
      });
      entity.label = new Cesium.LabelGraphics({
        text: (i + 1).toString(), // Set the label to the index + 1
        font: '14pt sans-serif',
        fillColor: Cesium.Color.WHITE,
        outlineColor: Cesium.Color.BLACK,
        outlineWidth: 2,
        style: Cesium.LabelStyle.FILL_AND_OUTLINE,
        verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
        pixelOffset: new Cesium.Cartesian2(0, -35) // Adjust the offset to position the label correctly
      });
    }

    this.viewer.flyTo(dataSource, { duration: 3 });
    this.viewer.dataSources.add(dataSource);
    this.viewer.scene.globe.depthTestAgainstTerrain = false;
  });
  }

  flyHome() {
    this.viewer.camera.flyHome(2); // take 2 seconds
  }

/** Call this after the map is created (e.g., ngAfterViewInit) */
initLatLonOverlay(): void {
  if (!this.map) return;

  // Create overlay div once
  this.latlonOverlay = document.createElement('div');
  Object.assign(this.latlonOverlay.style, {
    position: 'absolute',
    bottom: '18px',
    zIndex: '401',
    color: '#000',
    fontSize: '14px',
    padding:' 5px 4px 0px',
    left: '139px',
    fontFamily: 'Barlow, sans-serif !important',
    fontWeight: '600',
  });

  // Append into the map container
  this.map.getContainer().appendChild(this.latlonOverlay);
  this.latlonOverlay.innerHTML = `<div style="padding:0">Move cursor on map</div>`;

  const earthBounds = L.latLngBounds(
    [-85.05112878, -180],
    [85.05112878, 180]
  );

  this.latlonOutHandler = () => {
    if (this.latlonOverlay) {
      this.latlonOverlay.innerHTML = `<div style="padding:0">Out of Map</div>`;
    }
  };

  this.latlonMoveHandler = (e: L.LeafletMouseEvent) => {
    const containerBounds = this.map.getContainer().getBoundingClientRect();
    const pointer = e.originalEvent;
    if (
      pointer.clientX < containerBounds.left || pointer.clientX > containerBounds.right ||
      pointer.clientY < containerBounds.top || pointer.clientY > containerBounds.bottom ||
      !earthBounds.contains(e.latlng)
    ) {
      this.latlonOutHandler?.();
      return;
    }

    const lat = e.latlng.lat;
    const lng = e.latlng.lng;
    const latDMS = this.toDMS(lat, true);
    const lngDMS = this.toDMS(lng, false);
    const text = `Lng: ${lngDMS}, Lat: ${latDMS}`;
     this.latlonOverlay!.innerHTML = `<div style="padding:0">${text}</div>`;
  };

  // Attach listeners
  this.map.on('mousemove', this.latlonMoveHandler);
  // mouseout on container (DOM), because Leaflet's 'mouseout' can fire frequently among internal layers
  this.map.getContainer().addEventListener('mouseleave', this.latlonOutHandler);
}


destroyLatLonOverlay(): void {
  if (!this.map) return;
  if (this.latlonMoveHandler) this.map.off('mousemove', this.latlonMoveHandler);
  if (this.latlonOutHandler) this.map.getContainer().removeEventListener('mouseleave', this.latlonOutHandler);
  if (this.latlonOverlay?.parentElement) this.latlonOverlay.parentElement.removeChild(this.latlonOverlay);
  this.latlonOverlay = undefined;
  this.latlonMoveHandler = undefined;
  this.latlonOutHandler = undefined;
}

/** Decimal degrees -> DMS string with hemisphere (e.g., 12°34'56.7"N) */
private toDMS(value: number, isLat: boolean): string {
  const hem = isLat ? (value >= 0 ? 'N' : 'S') : (value >= 0 ? 'E' : 'W');
  const abs = Math.abs(value);
  const deg = Math.floor(abs);
  const minFloat = (abs - deg) * 60;
  const min = Math.floor(minFloat);
  const sec = (minFloat - min) * 60;

  // Format: omit 0° or 0' only if you want; this keeps them for stability
  const d = `${deg}°`;
  const m = `${min}'`;
  const s = `${sec.toFixed(1)}"`;
  return `${d}${m}${s}${hem}`;
}


  onKeyPress(e: any, msg: string) {
    if (e.key === 'Enter') {
      this.onNoClick(msg);
    }
  }
  onNoClick(msg: any): void {
    this.dialogRef.close('Done');   
  }

  plotArea(taskableAoi) {
    if (!this.map || !Array.isArray(taskableAoi) || taskableAoi.length === 0) {
      return;
    }

    const areaGroup = L.featureGroup();

    for (const file of taskableAoi) {
      this.taskTarget = file.taskableAoi;
      if (this.taskTarget) {
        if (this.taskTarget.type === 'Polygon') {
          const latLngs = this.taskTarget.coordinates[0].map(
            ([lng, lat]) => [lat, lng] as [number, number]
          );

   const polygon = L.polygon(latLngs, {
   color: 'yellow',
   weight: 2,
   fillColor: '#fff',
   fillOpacity: 0.1,
   }).addTo(areaGroup);
  const bounds = polygon.getBounds();
  const bottomLeft = bounds.getSouthWest();
  L.tooltip({
  permanent: true,
  direction: 'top', // shows above the point
  offset: [50, 50],
  className: 'custom-tooltip'
  })
  .setLatLng(bottomLeft)
  .setContent(file.fileName || 'Allowed Tasking Area')
  .addTo(areaGroup);
        }
      }
    }

    if (areaGroup.getLayers().length > 0) {
      this.geoJsonLayer = areaGroup.addTo(this.map);
      this.map.flyToBounds(areaGroup.getBounds(), {
        padding: [20, 20],
        duration: 1.5,
      });
    }
  }

 getSatelliteData() {
    let sensor = this.data['sensor'];
    let sensorName, sensorInfo;
    if (sensor?.key != OPERATORS.HEAD) {
      sensorName = [sensor?.name];
      sensorInfo = [{ key: sensor?.name, obfuscateName: sensor?.obfuscateName }];
    } else {
      sensorName = [sensor?.key];
      sensorInfo = [{ key: sensor?.key, obfuscateName: sensor?.obfuscateName }];
    }
    let sensorData = {};
    sensorData['sensorName'] = sensorName;
    sensorData['sensors'] = sensorInfo;
    sensorData['action'] = this.data['action'];

    if (this.data['action'] === 'projectedData') {
      let target = this.data['target'];
      sensorData['openWindow'] = moment.parseZone(target.openWindow)
        .utcOffset(0, true)
        .format();
      sensorData['closeWindow'] = moment.parseZone(target.closeWindow)
        .utcOffset(0, true)
        .format();
      sensorData['target'] = JSON.stringify(
        this.getSatelliteTrackingTarget(target?.geoJSON)
      );
    }

    const sensorObj = { sensorData: sensorData };
     if (this.satelliteDataSubscription) {
      this.satelliteDataSubscription.unsubscribe();
    }
   this.satelliteDataSubscription = this.apiService.getSatelliteData(sensorObj).subscribe((res: any) => {
      if (res?.msg === 'Failed') {
        this.dataLoading = false;
        const message = 'There are no active satellites for the chosen provider at this time. Please select another.';
        this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
      } else this.plotSatellitePath(res);
    });
  }

  private getSatelliteTrackingTarget(targetGeoJson: string): any {
    const parsedTarget = geoParse(targetGeoJson);

    if (!parsedTarget) {
      return parsedTarget;
    }

    if (parsedTarget.type === 'Polygon' || parsedTarget.type === 'MultiPolygon') {
      const centroid = turf.centroid(parsedTarget);
      return centroid.geometry;
    }

    return parsedTarget;
  }

      plotSatellitePath(result: any) {
    if (!this.map) return;
  
    // clear previous layer
    if (this.satLayer) {
      this.satLayer.clearLayers();
      this.map.removeLayer(this.satLayer);
    }
  
    this.ensureSatellitePane();
    this.satLayer = L.layerGroup([], { pane: 'satellitePane' });
    const targetGeometry = this.getSatelliteTrackingGeometry(this.data['target']);
    const isPointTarget = targetGeometry?.type === 'Point';
    const targetPoint = this.getTargetPointCoordinates(this.data['target']);
    const poi = targetPoint
      ? ([targetPoint.lat, targetPoint.lng] as L.LatLngTuple)
      : null;

    if (Array.isArray(result)) {
      if (poi) {
        let bestSatellite: any = null;
        let bestPass: SatelliteTrackPoint[] = [];
        let bestDistance = Infinity;

        result.forEach((satellite: any) => {
          const trackPoints = this.getSatelliteTrackDetails(satellite);
          if (trackPoints.length < 2) {
            return;
          }

          const nearestPassCandidate = this.getNearestPassWindow(trackPoints, poi);
          const nearestPass = nearestPassCandidate?.pass ?? null;
          const minDistance = nearestPassCandidate?.distance ?? Infinity;

          if (nearestPass && minDistance < bestDistance) {
            bestDistance = minDistance;
            bestSatellite = satellite;
            bestPass = nearestPass;
          }
        });

        if (bestPass.length && bestSatellite) {
          const color = this.getOperatorColor(
            this.data['sensor']?.key || this.data['sensor']?.name
          );

          const bestPassLine = L.polyline(
            bestPass.map((point) => point.latLng),
            {
              color,
              weight: 3,
              pane: 'satellitePane',
              interactive: true,
              renderer: this.satRenderer,
            }
          ).addTo(this.satLayer!);

          bestPassLine.bindTooltip('', {
            sticky: true,
            direction: 'top',
            opacity: 0.95,
          });

          bestPassLine.on('mousemove', (event: L.LeafletMouseEvent) => {
            const nearestPoint = this.getNearestTrackPoint(bestPass, [
              event.latlng.lat,
              event.latlng.lng,
            ]);
            bestPassLine.setTooltipContent(
              this.getSatelliteTooltipContent(bestSatellite, nearestPoint)
            );
            bestPassLine.openTooltip(event.latlng);
          });

          this.addSatelliteMarker(bestPass[0], bestSatellite);
        }

        if (isPointTarget) {
          L.marker(poi, {
            icon: L.icon({
              iconUrl:
                'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
              iconSize: [20, 20],
            }),
            pane: 'satellitePane',
            interactive: false,
          }).addTo(this.satLayer!);
        }

        this.satLayer.addTo(this.map);
        this.map.setView(poi, 4, { animate: false });
      } else {
        const color = this.getOperatorColor(
          this.data['sensor']?.key || this.data['sensor']?.name
        );

        result.forEach((satellite: any) => {
          const trackPoints = this.getSatelliteTrackDetails(satellite);
          const points = trackPoints.map((point) => point.latLng);
          if (!points.length) {
            return;
          }

          const validSegments = points.length > 1
            ? this.getValidOrbitSegments(points)
            : [];

          validSegments.forEach((currentSegment) => {
            const segmentLine = L.polyline(currentSegment, {
              color,
              weight: 2,
              pane: 'satellitePane',
              interactive: true,
              renderer: this.satRenderer,
            }).addTo(this.satLayer!);

            segmentLine.bindTooltip('', {
              sticky: true,
              direction: 'top',
              opacity: 0.95,
            });

            segmentLine.on('mousemove', (event: L.LeafletMouseEvent) => {
              const nearestPoint = this.getNearestTrackPoint(trackPoints, [
                event.latlng.lat,
                event.latlng.lng,
              ]);

              segmentLine.setTooltipContent(
                this.getSatelliteTooltipContent(satellite, nearestPoint)
              );
              segmentLine.openTooltip(event.latlng);
            });
          });

          this.addSatelliteMarker(trackPoints[trackPoints.length - 1], satellite);
        });

        this.satLayer.addTo(this.map);
        const bounds = L.featureGroup(this.satLayer.getLayers()).getBounds();
        if (bounds?.isValid()) {
          this.map.fitBounds(bounds, {
            padding: [20, 20],
            maxZoom: 6,
            animate: false,
          });
        } else {
          this.map.setView([15, 0], 2, { animate: false });
        }
      }
    }

    this.dataLoading = false;
  }

  private addSatelliteMarker(trackPoint: SatelliteTrackPoint, satellite: any): void {
    const position = trackPoint.latLng;
    const name =
      this.currentUser?.obfuscated && satellite.obfuscateName
        ? satellite.obfuscateName
        : satellite.name;
    const time = this.getSatelliteLabelTime(satellite, trackPoint);
    const tooltipContent = this.getSatelliteTooltipContent(satellite, trackPoint);
    const labelText = `<div class="satellite-label-line">${name}</div>
                 <div class="satellite-label-line">${time}</div>`;

    L.marker(position, {
      icon: L.icon({
        iconUrl: 'assets/images/satellite.png',
        iconSize: [25, 20],
        iconAnchor: [12.5, 20],
      }),
      pane: 'satellitePane',
      interactive: true,
      zIndexOffset: 1000,
    })
      .bindTooltip(tooltipContent, {
        sticky: true,
        direction: 'top',
        opacity: 0.95,
      })
      .addTo(this.satLayer!);

    L.marker(position, {
      icon: L.divIcon({
        className: 'satellite-label',
        html: labelText,
        iconSize: [130, 40],
        iconAnchor: [50, 20],
      }),
      pane: 'satellitePane',
      interactive: true,
    })
      .bindTooltip(tooltipContent, {
        sticky: true,
        direction: 'top',
        opacity: 0.95,
      })
      .addTo(this.satLayer!);
  }

  private getValidOrbitSegments(points: L.LatLngTuple[]): L.LatLngTuple[][] {
    if (points.length < 2) {
      return [];
    }

    const validSegments: L.LatLngTuple[][] = [];
    let segment: L.LatLngTuple[] = [points[0]];

    for (let i = 1; i < points.length; i++) {
      const prev = points[i - 1];
      const curr = points[i];
      const isBadJump = this.isSatelliteTrackJump(prev, curr);

      if (isBadJump) {
        if (segment.length > 1) {
          validSegments.push(segment);
        }
        segment = [];
      }

      segment.push(curr);
    }

    if (segment.length > 1) {
      validSegments.push(segment);
    }

    return validSegments;
  }

  private getTargetPointCoordinates(target: any): { lat: number; lng: number } | null {
    if (!target?.geoJSON) {
      return null;
    }

    const geometry = geoParse(target.geoJSON);
    if (!geometry) {
      return null;
    }

    if (
      (geometry.type === 'Polygon' || geometry.type === 'MultiPolygon')
    ) {
      const centroid = turf.centroid(geometry);
      const coordinates = centroid?.geometry?.coordinates;

      if (!Array.isArray(coordinates) || coordinates.length < 2) {
        return null;
      }

      const [lng, lat] = coordinates;
      if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
        return null;
      }

      return { lat, lng: this.normalizeLongitude(lng) };
    }

    if (geometry.type !== 'Point' || !Array.isArray(geometry.coordinates)) {
      return null;
    }

    const [lng, lat] = geometry.coordinates;
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
      return null;
    }

    return { lat, lng: this.normalizeLongitude(lng) };
  }

  private plotSatelliteTrackingTarget(): void {
    const geometry = this.getSatelliteTrackingGeometry(this.data['target']);

    if (!geometry) {
      return;
    }

    if (this.geoJsonLayer) {
      this.map.removeLayer(this.geoJsonLayer);
      this.geoJsonLayer = undefined;
    }

    if (geometry.type === 'Polygon' || geometry.type === 'MultiPolygon') {
      this.geoJsonLayer = L.geoJSON(geometry as GeoJSON.GeoJsonObject, {
        style: {
          color: '#80B1F6',
          weight: 2,
          fillOpacity: 0.1,
        },
        interactive: false,
      }).addTo(this.map);
    }
  }

  private getSatelliteTrackingGeometry(target: any): any {
    if (!target?.geoJSON) {
      return null;
    }

    return geoParse(target.geoJSON);
  }

  private getDistanceKm(a: L.LatLngTuple, b: L.LatLngTuple): number {
    const radius = 6371;
    const deltaLat = this.toRad(b[0] - a[0]);
    const deltaLon = this.toRad(b[1] - a[1]);
    const lat1 = this.toRad(a[0]);
    const lat2 = this.toRad(b[0]);

    const haversine =
      Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
      Math.cos(lat1) * Math.cos(lat2) *
      Math.sin(deltaLon / 2) * Math.sin(deltaLon / 2);

    return radius * 2 * Math.atan2(Math.sqrt(haversine), Math.sqrt(1 - haversine));
  }

  private toRad(value: number): number {
    return (value * Math.PI) / 180;
  }

  private getNearestPassWindow(
    points: SatelliteTrackPoint[],
    poi: L.LatLngTuple
  ): { pass: SatelliteTrackPoint[]; distance: number } | null {
    if (points.length < 2) {
      return null;
    }

    let nearestIndex = -1;
    let minDistance = Infinity;

    points.forEach((point, index) => {
      const distance = this.getDistanceKm(point.latLng, poi);
      if (distance < minDistance) {
        minDistance = distance;
        nearestIndex = index;
      }
    });

    if (nearestIndex === -1) {
      return null;
    }

    const pass = this.getContiguousPassAroundIndex(points, nearestIndex);

    return pass.length > 1 ? { pass, distance: minDistance } : null;
  }

  private getContiguousPassAroundIndex(
    points: SatelliteTrackPoint[],
    centerIndex: number
  ): SatelliteTrackPoint[] {
    if (!points.length || centerIndex < 0 || centerIndex >= points.length) {
      return [];
    }

    let startIndex = centerIndex;
    let endIndex = centerIndex;

    while (
      startIndex > 0 &&
      !this.isSatelliteTrackJump(
        points[startIndex - 1].latLng,
        points[startIndex].latLng
      )
    ) {
      startIndex--;
    }

    while (
      endIndex < points.length - 1 &&
      !this.isSatelliteTrackJump(
        points[endIndex].latLng,
        points[endIndex + 1].latLng
      )
    ) {
      endIndex++;
    }

    return points.slice(startIndex, endIndex + 1);
  }

  private isSatelliteTrackJump(prev: L.LatLngTuple, curr: L.LatLngTuple): boolean {
    const lonDiff = Math.abs(curr[1] - prev[1]);
    const latDiff = Math.abs(curr[0] - prev[0]);

    return lonDiff > 120 || latDiff > 60;
  }

  private getNearestTrackPoint(
    pass: SatelliteTrackPoint[],
    reference: L.LatLngTuple
  ): SatelliteTrackPoint | null {
    let nearestPoint: SatelliteTrackPoint | null = null;
    let minDistance = Infinity;

    pass.forEach((point) => {
      const distance = this.getDistanceKm(point.latLng, reference);
      if (distance < minDistance) {
        minDistance = distance;
        nearestPoint = point;
      }
    });

    return nearestPoint;
  }

  private getSatelliteTrackDetails(satellite: any): SatelliteTrackPoint[] {
    const positions = Array.isArray(satellite?.position) && satellite.position.length
      ? satellite.position
      : this.getFallbackSatellitePositions(satellite);

    return positions
      .map((position: SatellitePositionEntry | number[]) =>
        this.toSatelliteTrackPoint(position)
      )
      .filter((point): point is SatelliteTrackPoint => {
        return !!point && this.isSatellitePointWithinWindow(point.timeStamp);
      });
  }

  private getSatelliteTrackPoints(satellite: any): L.LatLngTuple[] {
    return this.getSatelliteTrackDetails(satellite).map((point) => point.latLng);
  }

  private getFallbackSatellitePositions(satellite: any): SatellitePositionEntry[] {
    if (!Number.isFinite(satellite?.latitude) || !Number.isFinite(satellite?.longitude)) {
      return [];
    }

    return [
      {
        coordinates: [satellite.longitude, satellite.latitude],
        timeStamp:
          satellite.timeStamp ||
          satellite.timestamp ||
          satellite.time,
      },
    ];
  }

  private toSatelliteTrackPoint(
    position: SatellitePositionEntry | number[]
  ): SatelliteTrackPoint | null {
    const coordinates = Array.isArray(position)
      ? position
      : position?.coordinates;

    if (!Array.isArray(coordinates) || coordinates.length < 2) {
      return null;
    }

    const [longitude, latitude] = coordinates;
    if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
      return null;
    }

    return {
      latLng: [latitude, this.normalizeLongitude(longitude)],
      timeStamp: Array.isArray(position)
        ? undefined
        : position.timeStamp || position.timestamp,
    };
  }

  private getSatelliteRawTime(
    satellite: any,
    trackPoint?: SatelliteTrackPoint | null
  ): string {
    return (
      trackPoint?.timeStamp ||
      satellite?.timeStamp ||
      satellite?.timestamp ||
      satellite?.time ||
      'No timestamp'
    );
  }

  private getSatelliteLabelTime(
    satellite: any,
    trackPoint?: SatelliteTrackPoint | null
  ): string {
    const rawTime = this.getSatelliteRawTime(satellite, trackPoint);
    const exactDateTime = moment.parseZone(rawTime, moment.ISO_8601, true);
    if (exactDateTime.isValid()) {
      return exactDateTime.format('HH:mm:ss');
    }

    const spacedDateTime = moment.parseZone(rawTime, 'YYYY-MM-DD HH:mm:ss', true);
    if (spacedDateTime.isValid()) {
      return spacedDateTime.format('HH:mm:ss');
    }

    return rawTime;
  }

  private getSatelliteTooltipTime(
    satellite: any,
    trackPoint?: SatelliteTrackPoint | null
  ): string {
    const rawTime = this.getSatelliteRawTime(satellite, trackPoint);
    const exactDateTime = moment.parseZone(rawTime, moment.ISO_8601, true);
    if (exactDateTime.isValid()) {
      return exactDateTime.format('DD MMM YYYY HH:mm:ss');
    }

    const spacedDateTime = moment.parseZone(rawTime, 'YYYY-MM-DD HH:mm:ss', true);
    if (spacedDateTime.isValid()) {
      return spacedDateTime.format('DD MMM YYYY HH:mm:ss');
    }

    return rawTime;
  }

  private getSatelliteTooltipContent(
    satellite: any,
    trackPoint?: SatelliteTrackPoint | null
  ): string {
    const name =
      this.currentUser?.obfuscated && satellite?.obfuscateName
        ? satellite.obfuscateName
        : satellite?.name;
    const time = this.getSatelliteTooltipTime(satellite, trackPoint);

    return `${name} - ${time}`;
  }

  private isSatellitePointWithinWindow(timeStamp?: string): boolean {
    const windowRange = this.getRequestedSatelliteWindow();

    if (!windowRange) {
      return true;
    }

    if (!timeStamp) {
      return false;
    }

    const pointTime = this.toWindowMoment(timeStamp, windowRange.openWindow);
    if (!pointTime) {
      return false;
    }

    const closeWindow = windowRange.closeWindow.isBefore(windowRange.openWindow)
      ? windowRange.closeWindow.clone().add(1, 'day')
      : windowRange.closeWindow;
    const comparisonPoint =
      pointTime.hasExplicitDate || !closeWindow.isAfter(windowRange.closeWindow)
        ? pointTime.value
        : pointTime.value.clone().add(1, 'day');

    return comparisonPoint.isBetween(
      windowRange.openWindow,
      closeWindow,
      undefined,
      '[]'
    );
  }

  private getRequestedSatelliteWindow(): {
    openWindow: moment.Moment;
    closeWindow: moment.Moment;
  } | null {
    if (this.data['action'] !== 'projectedData') {
      return null;
    }

    const target = this.data['target'];
    if (!target?.openWindow || !target?.closeWindow) {
      return null;
    }

    const openWindow = moment.parseZone(target.openWindow);
    const closeWindow = moment.parseZone(target.closeWindow);

    if (!openWindow.isValid() || !closeWindow.isValid()) {
      return null;
    }

    return { openWindow, closeWindow };
  }

  private toWindowMoment(
    timeStamp: string,
    referenceDate: moment.Moment
  ): { value: moment.Moment; hasExplicitDate: boolean } | null {
    const fullDateTime = moment.parseZone(timeStamp, moment.ISO_8601, true);
    if (fullDateTime.isValid()) {
      return { value: fullDateTime, hasExplicitDate: true };
    }

    const explicitDateTime = moment.parseZone(
      timeStamp,
      'YYYY-MM-DD HH:mm:ss',
      true
    );
    if (explicitDateTime.isValid()) {
      return { value: explicitDateTime, hasExplicitDate: true };
    }

    const timeOnly = moment.utc(timeStamp, 'HH:mm:ss', true);
    if (!timeOnly.isValid()) {
      return null;
    }

    const normalized = referenceDate.clone().set({
      hour: timeOnly.hour(),
      minute: timeOnly.minute(),
      second: timeOnly.second(),
      millisecond: 0,
    });

    return { value: normalized, hasExplicitDate: false };
  }

  private normalizeLongitude(longitude: number): number {
    return ((((longitude + 180) % 360) + 360) % 360) - 180;
  }
  
  private ensureSatellitePane() {
    if (!this.map.getPane('satellitePane')) {
      const pane = this.map.createPane('satellitePane');
      pane.style.zIndex = '650';
    }
    if (!this.satRenderer) {
      this.satRenderer = L.svg({ pane: 'satellitePane' });
      this.satRenderer.addTo(this.map);
    }
  }
  
  private getOperatorColor(key: string): string {
    switch (key) {
      case OPERATORS.CAPELLA: return 'yellow';
      case OPERATORS.SATELLOGIC: return 'yellowgreen';
      case OPERATORS.UMBRA: return 'blue';
      case OPERATORS.HEAD: return 'greenyellow';
      case OPERATORS.STE: return 'blueviolet';
      case OPERATORS.AT21: return 'green';
      case OPERATORS.KOMPSAT: return 'cyan';
      case OPERATORS.USL: return 'indigo';
      case OPERATORS.ISI: return 'turquoise';
      case OPERATORS.AXELSPACE: return 'gold';
      case OPERATORS.GHG: return '#25aae0';
      case OPERATORS.ORORATECH: return '#008B8B';
      case OPERATORS.WYVERN: return 'brown';
      case OPERATORS.SPIRE: return 'plum';
      case OPERATORS.CLYDE: return '#BC8F8F';
      case OPERATORS.SYNSPECTIVE: return 'green';
      case OPERATORS.GOKTURK: return '#9ce49c';
      case OPERATORS.LBAND: return 'violet';
      case OPERATORS.ECURS:
      case OPERATORS.ECURS_L: return 'aqua';
      case OPERATORS.ESPER: return 'deeppink';
      default: return 'royalblue';
    }
  }
   ngOnDestroy(): void {
    document.removeEventListener('fullscreenchange', this.fullscreenChangeHandler);
    this.map?.remove();
      if (this.satelliteDataSubscription) {
      this.satelliteDataSubscription.unsubscribe();
    }
    this.destroyLatLonOverlay()
    }
}
